import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ZatcaApiSetting
 *
 * @property {number} id
 */
export class ZatcaApiSetting extends Model {


}

AccessorsMutatorsDecorator(
  "id",
  "csid_obtained_at",
  "environment",
  "is_active",
  "is_complete",
  "last_used_at",
  "organization_identifier",
  "solution_name",
  "version",
  "is_expired",
)(ZatcaApiSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/zatca-api-setting.model.js